/* refresh variant-dependent product blocks when the shopper picks another variant.
   Any element with [data-nt-sync] and a stable id is re-rendered from the section HTML. */
(() => {
  if (window.__ntVariantSync) return;
  window.__ntVariantSync = true;
  let last = null, timer = null;

  const currentId = () => {
    const input = document.querySelector('form[action*="/cart/add"] [name="id"]');
    return input ? input.value : null;
  };

  const refresh = async (variantId) => {
    const targets = [...document.querySelectorAll('[data-nt-sync][id][data-section]')];
    if (!targets.length) return;
    const bySection = {};
    targets.forEach((el) => (bySection[el.dataset.section] ||= []).push(el));
    for (const [sectionId, els] of Object.entries(bySection)) {
      try {
        const url = `${location.pathname}?variant=${variantId}&section_id=${encodeURIComponent(sectionId)}`;
        const html = await (await fetch(url)).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        els.forEach((el) => {
          const fresh = doc.getElementById(el.id);
          if (fresh) { el.replaceWith(fresh); fresh.dispatchEvent(new CustomEvent('nt:synced', { bubbles: true })); }
        });
      } catch (e) { console.warn('nt-variant-sync', e); }
    }
  };

  const check = () => {
    const id = currentId();
    if (!id || id === last) return;
    const first = last === null;
    last = id;
    if (first) return;
    clearTimeout(timer);
    timer = setTimeout(() => refresh(id), 60);
  };

  document.addEventListener('change', () => setTimeout(check, 30), true);
  document.addEventListener('click', () => setTimeout(check, 120), true);
  document.addEventListener('DOMContentLoaded', check);
  check();
})();
